import React from 'react';
import { AppState } from './provider';
export interface ContextProps {
  state: AppState;
  dispatch: any;
}

export type TypeContextValue = ContextProps;

const Context = React.createContext<ContextProps | null>(null);
export default Context;

export const useGlobalStore = (): TypeContextValue => {
  const value = React.useContext(Context);
  if (!value) {
    throw new Error('useGlobalStore must under <GlobalDataProvider></GlobalDataProvider>');
  }

  return value;
};

